import ServiceBase from './ServiceBase';

export default class ProductRecommendationsService extends ServiceBase {
    getRecommendedProducts(params) {
        return this.request('get', 'productRecommendation/getRecommendedProducts', { ...params } );
    }
}
